/**
 * Set the page title
 */
export function setPageTitle(title: string) {
  document.title = title;
}

/**
 * Set meta tag content
 */
export function setMetaTag(name: string, content: string) {
  let metaTag = document.querySelector(`meta[name="${name}"]`);

  if (!metaTag) {
    metaTag = document.createElement('meta');
    metaTag.setAttribute('name', name);
    document.head.appendChild(metaTag);
  }

  metaTag.setAttribute('content', content);
}

/**
 * Set favicon dynamically
 */
export function setFavicon(href: string, type?: string) {
  // Get existing favicon links to recreate them
  const existingLinks = document.querySelectorAll(
    'link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]'
  );

  // Extract rel attributes from existing links
  const relTypes = Array.from(existingLinks).map(link => link.getAttribute('rel') || 'icon');

  // Remove existing favicon links
  existingLinks.forEach(link => link.remove());

  // Determine type
  let linkType = type;
  if (!linkType) {
    // Auto-detect type based on extension
    if (href.endsWith('.svg')) {
      linkType = 'image/svg+xml';
    } else if (href.endsWith('.png')) {
      linkType = 'image/png';
    } else if (href.endsWith('.ico')) {
      linkType = 'image/x-icon';
    }
  }

  // Create new favicon links for each rel type that existed
  const uniqueRelTypes = [...new Set(relTypes.length > 0 ? relTypes : ['icon'])];
  uniqueRelTypes.forEach(rel => {
    const link = document.createElement('link');
    link.rel = rel || 'icon';
    link.href = href;
    if (linkType) {
      link.type = linkType;
    }
    document.head.appendChild(link);
  });
}

/**
 * Set page meta information
 */
export function setPageMeta(options: {
  title?: string;
  description?: string;
  keywords?: string;
  author?: string;
  favicon?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
}) {
  const { title, description, keywords, author, favicon, ogTitle, ogDescription, ogImage } = options;

  if (title) {
    setPageTitle(title);
  }

  if (description) {
    setMetaTag('description', description);
  }

  if (keywords) {
    setMetaTag('keywords', keywords);
  }

  if (author) {
    setMetaTag('author', author);
  }

  if (favicon) {
    setFavicon(favicon);
  }

  // Open Graph tags
  if (ogTitle) {
    setMetaTag('og:title', ogTitle);
  }

  if (ogDescription) {
    setMetaTag('og:description', ogDescription);
  }

  if (ogImage) {
    setMetaTag('og:image', ogImage);
  }
}
